import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import Avatar from '@mui/material/Avatar';
import { useWeb3AuthConnect, useWeb3AuthUser } from '@web3auth/modal/react';

type avatarFormProps = {
  sxOptions: any;
};
export default function AvatarForm(payload: avatarFormProps) {
  const { sxOptions } = payload;
  const [avatar, setAvatar] = useState<string | undefined>('');

  const { isConnected } = useWeb3AuthConnect();
  const { userInfo } = useWeb3AuthUser();

  useEffect(() => {
    (async () => {
      if (isConnected && userInfo) {
        // setAvatar(re.profileImage);
        setAvatar(userInfo?.profileImage);
      }
    })();
    return () => {};
  }, [isConnected, userInfo]);

  return (
    <Avatar
      sx={{
        ...sxOptions,
      }}
      src={avatar}
    />
  );
}
